













  












function getSearchParam(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

function isStoredCampaignActive() {
  let storedCampaignStarts = localStorage.getItem("specialCampaignFrom");
  let storedCampaignEnds = localStorage.getItem("specialCampaignTo");
  const today = new Date().getTime();
  const storedCampaignIsActive = today >= storedCampaignStarts && today <= storedCampaignEnds;
  return storedCampaignIsActive;
}

let param = getSearchParam('utm_promo');
const campaignStarts = new Date('2024-11-30 23:00:00').getTime();
const campaignEnds = new Date('2025-12-23 23:59:59').getTime();

// set a new campaign + dates

if (param == '01DEC25.TESTGRINCH') {
    console.info("new campaign detected");
    localStorage.setItem("specialCampaign", '01DEC25.TESTGRINCH');
    localStorage.setItem("specialCampaignFrom", campaignStarts);
    localStorage.setItem("specialCampaignTo", campaignEnds);
}

// refresh stored dates just in case

let storedSpecialCampaign = localStorage.getItem("specialCampaign");
if (storedSpecialCampaign == '01DEC25.TESTGRINCH') {
    console.info("campaign dates refreshed");
    localStorage.setItem("specialCampaignFrom", campaignStarts);
    localStorage.setItem("specialCampaignTo", campaignEnds);
}

// check if stored campaign is active
const storedCampaignIsActive = isStoredCampaignActive();

// change the buttons if it proceeds

if (storedSpecialCampaign == '01DEC25.TESTGRINCH' && storedCampaignIsActive == true) {
    let logoMobile = document.querySelector('.header__mobile-logo');
    if (logoMobile){
      logoMobile.src = "//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24_small.png?v=15226407167513277813";
      logoMobile.srcset = "//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-small.png?22079 300w//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-medium.png?22079 600w//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-large.png?22079 1200w";
    }
    let logoDesktop = document.querySelector('.header__normal-logo');
    if (logoDesktop){
      logoDesktop.src = "//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24_small.png?v=15226407167513277813";
      logoDesktop.srcset = "//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-small.png?22079 300w//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-medium.png?22079 600w//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-large.png?22079 1200w";
    }
    let logoSticky = document.querySelector('.header__sticky-logo');
    if (logoSticky){
      logoSticky.src = "//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24_small.png?v=15226407167513277813";
      logoSticky.srcset = "//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-small.png?22079 300w//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-medium.png?22079 600w//walkinpitas.com/cdn/shop/files/LOGO_DESKTOP_4045888d-9f8b-4c19-8fdf-059e017d0d24.png-large.png?22079 1200w";
    }    

    let topBar = document.querySelector('.t4s-top-bar');
    let topBarMagic = document.querySelector('#withMagic');
    let topBarNoMagic = document.querySelector('#withoutMagic');
  
    if (topBar != null){
      topBar.style.backgroundColor = "#b0cd61";
    }   
    if (topBarMagic != null) {
          topBarMagic.style.display = "none";
    }
    if (topBarNoMagic != null) {
      topBarNoMagic.style.display = "block";
    } 
      
    let specialLabel = document.querySelector('#_special-collection-label');
    if (specialLabel) {
      specialLabel.style.display = "flex";  
    } 
  
    let specialCheckoutButton = document.querySelector("#_special-checkout-button");
    if (specialCheckoutButton) {
        specialCheckoutButton.style.display = "flex";
    }
  
    let specialRefreshButton = document.querySelector("#_special-refresh-button");
    if (specialRefreshButton) {
      specialRefreshButton.href = '&storefront=true';
      specialRefreshButton.style.display = "flex";  
    }
    
    let specialCartButton = document.querySelector("#_special-cart-button");
    if (specialCartButton) {
        specialCartButton.style.display = "block";
        let ordinaryCartButton = document.querySelector('a.t4s-btn__cart');
        ordinaryCartButton.style.display = "none";
    }

    let ordinaryCheckoutButton = document.querySelector('button[name="checkout"]');
    if (ordinaryCheckoutButton) {
      ordinaryCheckoutButton.style.display = "none";  
    }

    let bodyClasses = document.querySelector('body').classList;
    
      if(bodyClasses.contains("template-collection")){
        const promoImage = "<div class='t4s-product t4s-pr-grid t4s-col-item'><img class='_specialsales-promo-image' src='//walkinpitas.com/cdn/shop/files/Pitas_Grinch_descuento_ES_600x.jpg?v=7428690844763938148' /></div>";
        let productGrid = document.querySelector(".t4s_box_pr_grid");
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = promoImage;
        while (tempDiv.firstChild) {
          productGrid.insertBefore(tempDiv.firstChild, productGrid.firstChild); 
        }
        const shippingImage = "<img class='_specialsales-promo-image' src='//walkinpitas.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_600x.gif' />";
        let originalShippingProduct = document.querySelector(".t4s-pr-9009149608153");
        if(originalShippingProduct){
          originalShippingProduct.innerHTML = shippingImage;   
        }
        
      }
    
  
    if(bodyClasses.contains("template-product")){
      const promoText = "<span style='color: #b0cd61'>Añade el producto al carrito y haz click en <b>Aplicar descuentos y tramitar pedido</b> para ver el precio final.</span>";
      let priceDiv = document.querySelector(".t4s-product__price");
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = promoText;
      while (tempDiv.firstChild) {
        priceDiv.insertBefore(tempDiv.firstChild, priceDiv.firstChild); 
      }
    }
    
    document.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel, index, array) {
      if ( isStoredCampaignActive()) {
        specialDiscountLabel.style.display = "block";    
      }
    });


    // infinite scroll tags
    const config = { childList: true, subtree: true }; 
    
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.classList && node.classList.contains('t4s-product') && isStoredCampaignActive()) {
              node.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel, index, array) {
                specialDiscountLabel.style.display = "block";
              });
            }
          });
        };
      }
    }
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observer.observe(document.body, config);
    
    }
